// API service for Content Craft
import axios from 'axios';
const API_URL = process.env.REACT_APP_BACKEND_URL;


const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const login = async (credentials) => {
  try {
    const response = await api.post('/user/login', credentials);
    localStorage.setItem('token', response.data.token);
    return response.data;
  } catch (err) {
    console.error('Login error:', err);
    throw err;
  }
};

export const register = async (credentials) => {
  try {
    const response = await api.post('/user/register', credentials);
    return response.data;
  } catch (err) {
    console.error('Registration error:', err);
    throw err;
  }
};

export const getProfile = async () => {
  try {
    const response = await api.get('/user/profile');
    return response.data;
  } catch (err) {
    console.error('Profile fetch error:', err);
    throw err;
  }
};

export const getProfileStats = async () => {
  try {
    const response = await api.get('/api/users/profile/stats');
    return response.data;
  } catch (err) {
    console.error('Profile stats fetch error:', err);
    throw err;
  }
};

export const updateProfile = async (data) => {
  try {
    const response = await api.put('/api/users/profile/update', data);
    return response.data;
  } catch (err) {
    console.error('Profile update error:', err);
    throw err;
  }
};

export const updatePassword = async (data) => {
  try {
    const response = await api.put('/api/users/profile/password', data);
    return response.data;
  } catch (err) {
    console.error('Password update error:', err);
    throw err;
  }
};

export const getCreatives = async ({ currentPage, searchTerm, selectedLanguages, selectedTypes, selectedCreativeTypes, selectedCreatedBy, selectedStatuses, selectedTags, startDate, endDate }) => {
  try {
    const response = await api.get('/library/creatives', {
      params: {
        page: currentPage,
        limit: 10,
        search: searchTerm,
        language: selectedLanguages,
        type: selectedTypes,
        creativeType: selectedCreativeTypes,
        createdBy: selectedCreatedBy,
        status: selectedStatuses,
        tags: selectedTags,
        startDate,
        endDate,
      },
    });

    return response.data;
  } catch (err) {
    console.error('Error fetching creatives:', err);
    throw err;
  }
};


export const logout = () => {
  localStorage.removeItem('token');
  console.log('Logged out, token removed');
};

export default api;
